import { useSyncExternalStore } from 'react';
import { sessionStore } from '../lib/session-store';
import type { StoredSession } from '../schemas/stored-session';

export function useSession(): StoredSession | null {
  return useSyncExternalStore(sessionStore.subscribe, sessionStore.read);
}
